<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gHtkK/tc-custom/9781467448369.jpg?1730410220506" alt="This image is the cover for the book Four Birds of Noah's Ark"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Four Birds of Noah's Ark
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A timeless, little-known literary classic to engage a new generation of readers</i></b> </p><p>As the Black Death ravaged London in 1608, in the midst of societal chaos and tragedy, playwright Thomas Dekker wrote <i>Four Birds of Noah’s Ark</i>, a book containing fifty-six prayers for the people of London and all of England.</p><p>                The prayers in this book bear witness to Dekker’s deep faith with a power and poignancy that few written prayers in English literature achieve. Bringing Dekker’s devotional classic back into print for the first time since 1924, editor Robert Hudson has annotated the prayers and modernized their language without sacrificing their enchanting beauty and simplicity. Hudson’s substantive and illuminating introduction is a gem in itself.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Dekker, Robert Hudson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a8edda6